import {getParameterByName} from '../../../shared/scripts/ui_utils/ClientUtils'
import {UIWStoreBodyController} from './UIWStoreBodyController'
import {notificationController} from '../../../shared/scripts/EntryShared'
import {UITopNotificationType} from '../../../shared/scripts/notifications/UINotificationController'
import {UIStoreState} from '../../../shared/scripts/store/UIStoreState'
import {UIStoreController} from '../../../shared/scripts/store/UIStoreController'

export class UIWStoreController extends UIStoreController {
    protected storeState: UIStoreState
    bodyController: UIWStoreBodyController
    readonly headerCoinsContainer: HTMLDivElement

    constructor() {
        super()
        this.init()
        UIWStoreController.showSuccessBanner()
    }

    protected init() {
        this.storeState = new UIStoreState(this)
        this.bodyController = new UIWStoreBodyController(this.storeState)
    }

    private static showSuccessBanner() {
        const purchaseSuccess = getParameterByName('purchase-success')
        if(purchaseSuccess != '1') return
        notificationController.show({key: 'strings:storePage.success.purchaseSuccess'}, UITopNotificationType.Purchase)
    }
}
